<template>
    <form method="post" name="qna_form" v-on:submit.prevent="registerQna">
        <table class="c-hyo-form-table">
            <tbody>
            <tr>
                <th><label class="u-text-nowrap" for="qna_name">이름*</label></th>
                <td><input id="qna_name" name="name" required type="text" v-model="iname"></td>
            </tr>
            <tr>
                <th><label class="u-text-nowrap" for="qna_phone">연락처</label></th>
                <td>
                    <input id="qna_phone" name="phone" type="text" v-model="phone">
                </td>
            </tr>
            <tr>
                <th><label class="u-text-nowrap" for="qna_email">이메일*</label></th>
                <td>
                    <input id="qna_email" name="email" required type="email" v-model="email">
                </td>
            </tr>
            <tr>
                <th><label class="u-text-nowrap" for="qna_subject">제목*</label></th>
                <td>
                    <input id="qna_subject" name="subject" required type="text" v-model="subject">
                </td>
            </tr>
            <tr>
                <th><label class="u-text-nowrap" for="qna_content">내용*</label></th>
                <td><textarea id="qna_content" name="content" placeholder="문의하실 내용을 적어주세요" required rows="5"
                              v-model="content"></textarea></td>
            </tr>
            </tbody>
        </table>
        <p class="u-text-center">
            <button class="c-btn  c-btn--primary" type="submit">저장</button>

            <button @click="test" class="c-btn  c-btn--default" type="button" v-if="app_env === 'local'">테스트</button>
        </p>

    </form>
</template>

<script>
    export default {
        name: "QnaForm",
        props: ["marxism"],
        data() {
            return {
                iname: '',
                phone: '',
                email: '',
                subject: '',
                content: '',
                app_env: $('#app_env').content,
            }
        },
        methods: {
            registerQna() {
                axios.post('/qna/save', {
                    iname: this.iname,
                    phone: this.phone,
                    email: this.email,
                    subject: this.subject,
                    content: this.content
                })
                    .then(res => {

                        const message = res.data.message;

                        if (res.data.result === 'fail') {
                            throw message;
                        } else if (res.data.result === 'success') {
                            swal({
                                icon: 'success',
                                text: message
                            }).then(() => {
                                this.iname = '';
                                this.phone = '';
                                this.email = '';
                                this.subject = '';
                                this.content = '';
                            });
                        }
                    })
                    .catch(error => {
                        swal({
                            title: '오류가 발생했습니다.',
                            text: error + "",
                            icon: 'error',
                        })
                    });
            },
            test() {
                this.iname = '테스트';
                this.phone = '010-1234-1234';
                this.email = 'test@test.com';
                this.subject = '7월 임시국회 개문발차..\'추경 vs 안보국회\' 꿈쩍않는 여야';
                this.content = '(서울=뉴스1) 김정률 기자 = 7월 임시국회 소집을 하루 앞둔 28일 더불어민주당과 자유한국당이 여전히 이견을 좁히지 못하고 있어 국회 정상화를 이뤄낼 수 있을지 주목된다.\n' +
                    '\n' +
                    '앞서 한국당과 바른미래당은 지난 26일 경제·안보 위기를 극복하기 위한 7월 임시국회 요구서를 공동 제출했다. 이에 29일부터 7월 임시국회 회기가 시작된다.\n' +
                    '\n' +
                    '하지만 본회의를 비롯한 의사일정을 잡기는 쉽지 않을 전망이다. 여야 간 입장이 팽팽히 맞서고 있기 때문이다. 여기에 이인영 민주당 원내대표가 \'DMZ 통일걷기\'를 위해 여의도를 비우면서 여야 협상은 더욱 어려워졌다.\n' +
                    '\n' +
                    '이에 여야 원내수석 간 회동 등 실무진 협상 여부가 주목됐으나 양측 모두 \'만날 계획이 없다\'는 입장을 밝히는 등 난항을 거듭하고 있어 가뜩이나 어두운 7월 임시 국회 전망은 더욱 암울해지고 있다. ';
            }

        },


    }
</script>

<style scoped>

</style>
